module.exports = __webpack_public_path__ + "static/4-8928153039ebfc6b135cd82f43181d5b.jpg";